import { useMutation } from '@gogame/query';

import { bulkUpload } from '../../sources/playersInformation';
import { update } from '../queryKeyFactory';

export const useBulkUpload = (params) => {
  const bulkUploadMutation = useMutation(update(params), bulkUpload, {
    successMessage: () =>
      'Thank you for submitting your request we will work on it and will email you the result within a day',
  });

  const handleAction = async (params) => {
    await bulkUploadMutation.mutateAsync(params);
  };

  return [handleAction, bulkUploadMutation];
};
